import React, { useEffect, useRef, useState } from 'react';

/**
 * PressioneLunga — un pulsante che parte solo se lo si tiene premuto.
 *
 * PERCHE' (Alex, 26 settembre 2026, blocco 2 punto M). «Timbra entrata /
 * uscita» sta sulla schermata d'attesa del tablet, la stessa che ha in
 * mano chi aspetta: un tocco per sbaglio apriva la timbratura davanti al
 * paziente. Tenere premuto per due secondi e' un gesto che non si fa per
 * caso, e il personale lo impara in una volta.
 *
 * COME SI VEDE: mentre si tiene premuto, una barra si riempie da sinistra;
 * se si lascia prima, si svuota e non succede niente. Arrivata in fondo,
 * parte l'azione. Il tempo e' uno solo, scritto qui e nel CSS
 * (--pl-durata), perche' la barra e il timer devono finire insieme.
 *
 * Tocco, mouse e penna passano dai Pointer Events; da tastiera si tiene
 * premuto Invio o la barra spaziatrice. Il menu del tocco lungo del
 * sistema (copia, seleziona) si spegne: comparirebbe proprio a meta'.
 * E il browser non si prende il gesto per uno scorrimento: touch-action
 * none su .pl-pulsante (styles/Tablet.css, col perche'). Senza, un dito
 * che scivola manda pointercancel e la pressione si annulla in silenzio.
 */
export const DURATA_MS = 2000;

const PressioneLunga = ({ onCompletata, className = '', children, suggerimento }) => {
    const [premuto, setPremuto] = useState(false);
    const timer = useRef(null);

    const annulla = () => {
        if (timer.current) clearTimeout(timer.current);
        timer.current = null;
        setPremuto(false);
    };
    const inizia = () => {
        if (timer.current) return;          // la tastiera ripete il keydown
        setPremuto(true);
        timer.current = setTimeout(() => {
            timer.current = null;
            setPremuto(false);
            onCompletata();
        }, DURATA_MS);
    };
    useEffect(() => () => { if (timer.current) clearTimeout(timer.current); }, []);

    return (
        <button
            type="button"
            className={`pl-pulsante ${premuto ? 'pl-premuto' : ''} ${className}`}
            style={{ '--pl-durata': `${DURATA_MS}ms` }}
            onPointerDown={(e) => { if (e.button === 0 || e.pointerType !== 'mouse') inizia(); }}
            onPointerUp={annulla}
            onPointerLeave={annulla}
            onPointerCancel={annulla}
            onContextMenu={(e) => e.preventDefault()}
            onKeyDown={(e) => { if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); inizia(); } }}
            onKeyUp={(e) => { if (e.key === 'Enter' || e.key === ' ') annulla(); }}
            onClick={(e) => e.preventDefault()}   // il clic breve non fa niente
            aria-label={typeof children === 'string' ? `${children} (tieni premuto)` : undefined}
        >
            <span className="pl-riempimento" aria-hidden="true" />
            <span className="pl-testo">{children}</span>
            {suggerimento && <span className="pl-suggerimento">{suggerimento}</span>}
        </button>
    );
};

export default PressioneLunga;
